import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import { NotFoundError } from "@/modules/errors";

import { useProjectPooling } from "@/hooks/use-project-pooling";
import getPath from "@/modules/get-path";
import { hasProjectReportFinished, isProjectReportGenerating } from "@/utils";
import Analysis from "./analysis";
import GenerateReport from "./report/generate";

export default function AiAnalysisView() {
  const { project } = useOutletContext();

  if (!project.isPromptEnabled) {
    throw new NotFoundError();
  }

  const [isPooling, setIsPooling] = useState(
    isProjectReportGenerating(project),
  );

  const pooling = useProjectPooling(
    `${getPath(project)}`,
    project,
    null,
    isPooling,
    10000,
  );

  useEffect(() => {
    if (hasProjectReportFinished(pooling.project) && isPooling) {
      setIsPooling(false);
    }
  }, [pooling.project, isPooling]);

  return (
    <div className="mt-10 w-full">
      <Analysis project={pooling.project} isPooling={isPooling} />
      <GenerateReport
        project={pooling.project}
        isPooling={isPooling}
        setIsPooling={setIsPooling}
      />
    </div>
  );
}
